import { useEffect, useState } from "react";
import useTypedSequence from "@/hooks/useTypedSequence";
import { fireworks } from "@/lib/confetti";
import { toast } from "sonner";

/**
 * Site-wide easter eggs:
 *  - Type "secqre" anywhere → yellow tape sweeps the screen + fireworks
 *  - Type "honk"  anywhere → toast + small shake
 */
export default function EasterEggs() {
  const [tape, setTape] = useState(false);

  useTypedSequence("secqre", () => {
    setTape(true);
    fireworks();
    toast.success("🟡 SECQRE unlocked. Privacy mode: maximum.");
    setTimeout(() => setTape(false), 2200);
  });

  useTypedSequence("honk", () => {
    toast("📣 HONK! HONK!", { description: "Tap any car. Politely." });
  });

  useTypedSequence("park", () => {
    toast("🅿️  Pro tip", { description: "Type 'secqre' for a surprise." });
  });

  // Subtle shake when tape triggers
  useEffect(() => {
    if (!tape) return;
    document.body.style.animation = "secqre-shake 0.5s ease-in-out 1";
    const t = setTimeout(() => (document.body.style.animation = ""), 600);
    return () => clearTimeout(t);
  }, [tape]);

  return (
    <>
      <style>{`
        @keyframes secqre-shake { 0%,100%{transform:translateX(0)} 25%{transform:translateX(-6px)} 75%{transform:translateX(6px)} }
        @keyframes tape-sweep {
          0% { transform: translateX(-110%) rotate(-6deg); }
          100% { transform: translateX(110%) rotate(-6deg); }
        }
      `}</style>
      {tape && (
        <div className="fixed inset-0 z-[100] pointer-events-none overflow-hidden" data-testid="easter-tape">
          <div
            className="absolute top-1/2 left-0 right-0 h-24 -translate-y-1/2 bg-[#FFD600] flex items-center"
            style={{ animation: "tape-sweep 1.6s cubic-bezier(.22,.61,.36,1) forwards" }}
          >
            <div className="whitespace-nowrap font-heading font-black text-[#0A0A0A] text-3xl md:text-5xl tracking-tight">
              {Array.from({ length: 20 }).map((_, i) => (
                <span key={i} className="mx-6">SECQRE · PRIVATE BY DESIGN ·</span>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
